import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material';

import './style/main.css';
import Auth from './components/Module/Auth/Auth';
import { useAppDispatch, useAppSelector } from './hooks/redux';
import Context, { IConfig } from './services/context.service';
import MainLayout from './components/Module/Main/Layout/MainLayout';
import { getDataFromLocalStorage } from './utils/methods';
import { changeLanguageApp, userLogin, userLogout } from './store/actions/userAction';
import { IPermTypes } from './store/reducers/userReducer';
import { ukUA } from '@mui/material/locale';
import ModalMessage from './components/UI/Modal/ModalOld';
import Loading from './components/UI/Loading/Loading';
import { ILocale } from './services/localize.service';
import MainLayout2 from './components/Module/Main/Layout/MainLayout2';


const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#000',
      light: '#fff',
      dark: '#999',
      contrastText: '#d3d3d3',
    },
    secondary: {
      main: '#2C78D9',
      light: '#6ea6ff',
      dark: '#004da7',
      contrastText: '#fdfdfd',
    },
    contrastThreshold: 3,
    divider: '#000',
  },
}, ukUA);


function App() {

  /* Получение языковой локали */
  const { locale } = useAppSelector(state => state.user);

  const { isAuth } = useAppSelector(state => state.user.users);

  const dispatch = useAppDispatch();

  const [customTheme, setCustomTheme] = useState<any>();

  const [config, setConfigApp] = useState<IConfig>();

  const getCustomTheme = async () => {
    const setting = await fetch('config.json').then(function(response) {
      return response.json();
    });

    if (setting) {
      if (setting.config) setConfigApp({ ...setting.config }); else setConfigApp({
        locale: { auth: {} }, loginFormat: 0, companyInfoAfterLoginLocated: '',
      });
      setCustomTheme(createTheme(setting.profile));
    }
  };


  /* Проверка на существующую авторизацию, сразу логинимся если есть прошлая атворизация в localStorag'e */
  useEffect(() => {

    const locale = getDataFromLocalStorage('languageApp') as ILocale;
    locale && dispatch(changeLanguageApp(locale));

    const token: { token: string, isAuth: boolean } = JSON.parse(getDataFromLocalStorage('token') as string);

    if (token && token.isAuth) {

      const permissions: IPermTypes[] = JSON.parse(getDataFromLocalStorage('permissions') as string);

      dispatch(userLogin({ permissions }));
    } else {
      dispatch(userLogout());
    }

    /* Попытка подвязать кастомную тему из json */
    getCustomTheme().then();

  }, []);

  //const matches = useMediaQuery( '(min-width:600px)' );

  if (!customTheme) {
    return <Loading type={'fullScreen'} />;
  }

  return (
    <ThemeProvider theme={customTheme ? customTheme : theme}>
      <Context.Provider value={{ locale, config: config as IConfig }}>
        {isAuth ? <MainLayout /> : <Auth />}
        <ModalMessage />
      </Context.Provider>
    </ThemeProvider>
  );
}

export default App;
